import { render, staticRenderFns } from "./wholeProcessDetail.vue?vue&type=template&id=6346b84a&scoped=true&"
import script from "./wholeProcessDetail.vue?vue&type=script&lang=tsx&"
export * from "./wholeProcessDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./wholeProcessDetail.vue?vue&type=style&index=0&id=6346b84a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346b84a",
  null
  
)

export default component.exports